// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"803":"3aae54eb","1235":"a68e8552","2094":"26e8bdd7","2750":"b32c3c32","6083":"911ab62b","6090":"3aae54eb","9697":"b32c3c32"}[chunkId] + ".chunk.css";
};